enum VehicleGroupLabel {
    SUV_WAGON = 'SUV / Wagon',
    PICKUP_UTE = 'Pickup / Ute',
    COUPE_CONVERTIBLE_SPORT = 'Coupe / Convertible / Sport',
    PASSENGERVAN_MONOSPACE = 'Passenger Van',
    CAR = "Car",
    COMMERCIAL_VAN_TRUCK = "Commercial Van / Truck"
}

export default VehicleGroupLabel;
